/**
 * Add Email Recipients Plugin
 */
(function ($) {

    "use strict";

    $.fn.addEmailRecipients = function (options) {

        const $parent = $(this);

        const construct = {
            recipientsUsed: {},

            emailRecipients: [],

            suggestedRecipients: [
                'hello@ambuilding.co.uk',
                'matt@sub85.com',
                'hello@bbc.com',
            ],

            init : function () {
                let _this = this;

                /**
                 * Populate recipientsUsed
                 */
                _this.emailRecipients = JSON.parse(addEmailRecipients.defaultRecipients);
                for (let i = 0; i <= _this.emailRecipients.length;i++) {
                    if (_this.suggestedRecipients.indexOf(_this.emailRecipients[i]) > -1) {
                        _this.recipientsUsed[_this.emailRecipients[i]] = true
                    }
                }

                /**
                 * Create and add the add recipients buttons into the DOM
                 */
                _this.setupAvailableAddRecipientButtons();

                let $addToEmailButtons = $('.' + addEmailRecipients.buttonClass);

                /**
                 * Add event listeners to add recipient buttons
                 */
                $addToEmailButtons.on('click', function() {
                    let recipient = $(this).html();
                    if (_this.recipientsUsed[recipient]) {
                        return;
                    }

                    _this.emailRecipients.push(recipient);
                    addEmailRecipients.multipleEmailsInput.val(recipient).trigger('blur');
                    $(this).addClass('strike-through');
                    $(this).addClass('disabled');
                    _this.recipientsUsed[recipient] = true;
                });

                /**
                 * Listen for input changing
                 */
                addEmailRecipients.targetInput.on('change', function (event, emails) {
                    if (emails) {
                        _this.emailRecipients = JSON.parse(emails);
                    } else {
                        _this.emailRecipients = [];
                    }
                    _this.recipientsUsed = {};
                    for (let i = 0; i < _this.emailRecipients.length; i++) {
                        _this.recipientsUsed[_this.emailRecipients[i]] = true;
                    }

                    $addToEmailButtons.each(function() {
                        let recipient = $(this).html();
                        if (!_this.recipientsUsed[recipient]) {
                            $(this).removeClass('strike-through')
                                .removeClass('disabled');
                        }
                    });
                });

                return _this;
            },

            setupAvailableAddRecipientButtons: function () {
                let _this = this;
                for (let i = 0; i < _this.suggestedRecipients.length;i++) {
                    let styleClass = '';
                    if (_this.recipientsUsed[_this.suggestedRecipients[i]]){
                        styleClass = 'strike-through disabled';
                    }
                    $parent.append(
                        $('<span/>')
                            .attr('role', 'button')
                            .addClass('btn btn-sm btn-outline-secondary ' + addEmailRecipients.buttonClass + ' ' + styleClass)
                            .css('margin-right', '10px')
                            .html(_this.suggestedRecipients[i])
                    );
                }
            },
        };

        const addEmailRecipients = $.extend(construct, {}, options);
        addEmailRecipients.init();

        return $parent;
    };

}(jQuery));
